import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import * as _ from "lodash";

@Component({
  selector: "group",
  templateUrl: "./group.component.html",
  styleUrls: ["./group.component.scss"],
})
export class GroupComponent implements OnInit {
  @Input()
  groupData;

  @Input()
  canBeDeleted;

  @Input()
  groupingUnitPlural;

  @Input()
  showLeftArrow;

  @Input()
  showRightArrow;

  @Input()
  groupingTemplateId;

  @Output() groupSelected = new EventEmitter();

  @Output() groupEdited = new EventEmitter();
  @Output() groupDeleted = new EventEmitter();

  @Output() groupMovedLeft = new EventEmitter();
  @Output() groupMovedRight = new EventEmitter();

  searchTerm;
  filteredItems;
  infoTooltipText;
  moveGroupTooltipText;
  editGroupTooltipText;
  deleteGroupTooltipText;
  placeholderText;
  infoTooltipObj;
  maxLength: number = 25;

  constructor() {}

  ngOnInit() {
    this.infoTooltipText = `New values will be added here automatically.`;
    if (this.groupingTemplateId == 14) {
      // Behaviour category
      this.infoTooltipText =
        this.infoTooltipText +
        ` Values will be counted toward Office Discipline Referral metrics.`;
    }
    this.moveGroupTooltipText =
      "Change order. Order is used for trend line sequence and latest period results.";
    this.editGroupTooltipText = "Edit category.";
    this.deleteGroupTooltipText =
      "Delete category. Values will be added to the default category.";
    this.placeholderText = `Search for ${this.groupingUnitPlural}`;
    if (this.groupingTemplateId == 12) {
      // Exit codes
      this.infoTooltipObj = {
        "Completed Highest Grade in Elementary or Middle School": `Completed Highest Grade in Elementary or Middle School: values identify students
        who have completed the terminal grade of an elementary or middle school. Values in this category will count as retained for the school retention
        metric. If you do not have a code for this status, please leave this category blank and we will use alternate logic to determine which students completed
        the highest grade for the school.`,
        Graduated:
          "Graduated: values will be considered retained for retention metrics.",
        "Transferred within District":
          "Transferred within District: values will be considered retained for District retention and not retained for School retention.",
        "Transferred out of District":
          'Transferred out of District: values are considered "not retained" in retention rate calculations.',
        "Other Exclusions":
          "Other Exclusions: values identify students who should be excluded from the denominator for year-over-year retention. Examples are students who have emigrated or passed away.",
        "Dropped Out":
          "Dropped Out: values identify students who have left the district with no evidence of re-enrollment in school.",
        "Retained in Grade":
          "Retained in Grade: values identify students who have been retained in a grade and are considered as retained for retention metric.",
      };
    } else if (this.groupingTemplateId == 1) {
      // Behaviour response
      this.infoTooltipObj = {
        "Not Office Referral":
          "Not Office Referral: add responses that should be excluded when calculating Office Discipline Referral Rate metrics.",
        Suspensions:
          "Suspensions: add responses that should be included when calculating Suspension metrics.",
        Expulsions:
          "Expulsions: add responses that should be included when calculating Expulsion metrics.",
      };
    } else if (this.groupingTemplateId == 14) {
      // Behaviour category
      this.infoTooltipObj = {
        "Classroom-Managed (Minor)":
          "Classroom-Managed (Minor): use this category for behavior values that are handled by classroom or non-office staff and do not count as an office discipline referral.",
        "Office-Managed (Minor, Major)":
          "Office-Managed (Minor, Major): use this category for behavior values that will count as an office discipline referral.",
        "Other Exclusions": `Other Exclusions: use this category for behavior values that should not count as either
          office-managed or classroom-managed and should be excluded from behavior metrics and reports.`,
      };
    } else {
      this.infoTooltipObj = {};
    }
  }

  clearFilters() {
    this.searchTerm = null;
    this.filteredItems = null;
  }

  groupChecked() {
    if (this.groupData.selectAll && !this.hasAllBoxesChecked()) {
      // if we currently have "selectAll" checked, but we don't have all the boxes checked, then we aren't selecting all anymore
      this.groupData.selectAll = false;
    } else if (!this.groupData.selectAll && this.hasAllBoxesChecked()) {
      this.groupData.selectAll = true;
    }
    this.groupSelected.emit(this.groupData);
  }

  hasAllBoxesChecked() {
    if (this.filteredItems && this.filteredItems.length > 0) {
      return _.every(this.filteredItems, ["checked", true]);
    } else {
      return _.every(this.groupData.results, ["checked", true]);
    }
  }

  selectAllClicked() {
    _.map(this.groupData.results, (result: any) => {
      // if we have no filtered list, or if we've filtered the list and the group is in the list of filtered items, then selectAll will affect it
      if (
        !this.filteredItems ||
        (this.filteredItems.length > 0 &&
          _.find(this.filteredItems, ["name", result.name]))
      ) {
        result.checked = this.groupData.selectAll;
      }
    });
    this.groupChecked();
  }

  editGroup(groupData) {
    this.groupEdited.emit(groupData);
  }

  deleteGroup(groupData) {
    this.groupDeleted.emit(groupData);
  }

  searchTermChanged(newValue) {
    this.searchTerm = newValue;
    this.filteredItems = _.filter(this.groupData.results, (result: any) => {
      return result.name.toLowerCase().includes(this.searchTerm.toLowerCase());
    });
    // when we filter, we should un-check any boxes that aren't visible anymore
    this.groupData.results.map((result) => {
      if (!_.find(this.filteredItems, ["name", result.name])) {
        return (result.checked = false);
      }
    });
    if (this.groupData.selectAll) {
      // if we have selectAll selected, we select any ones that are still visible once filtered
      this.selectAllClicked();
    } else {
      this.groupChecked();
    }
  }

  getResults() {
    return this.filteredItems ? this.filteredItems : this.groupData.results;
  }

  moveLeft(groupData) {
    this.groupMovedLeft.emit(groupData);
  }

  moveRight(groupData) {
    this.groupMovedRight.emit(groupData);
  }
}
